import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, FormGroup, Button } from 'reactstrap';
import { register } from '../../redux';
import PasswordInput, { usePasswordStrength } from '../../components/PasswordInput';
import { isAccountAlreadyExistsError } from './registerError';

import './RegisterForm.css';

import logo  from '../../assets/images/Kronos.svg';

const RegisterForm = ({ tkt_instance_id, hide_logo, appear }) => {
    const { t, i18n }    = useTranslation();
    const dispatch = useDispatch();

    const [data, setData] = useState({
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        "password-confirmation": '',
        tkt_instance_id
    });

    const { registerErrorMessage, isRegistering, registerError } = useSelector(state => state.auth);

    const passwordStrength = usePasswordStrength(data.password, {
        language: i18n.language,
        userInputs: [data.email, data.firstname, data.lastname],
    });

    const canSubmit =
        data.password !== '' &&
        data['password-confirmation'] !== '' &&
        data.password === data['password-confirmation'] &&
        passwordStrength.acceptable &&
        !isRegistering;

    const submit = e => {
        e.preventDefault();
        if (!canSubmit) {
            return;
        }
        dispatch(register(data));
    }

    return (
        <Form onSubmit={ submit } className={`RegisterForm ${appear ? 'appear' : ''}`}>
            {!hide_logo && (
                <img className="logo" src={logo} alt="logo" />
            )}
            <FormGroup row>
                <Col>
                    <input
                        required
                        type="text"
                        autoComplete="username firstname"
                        name="firstname"
                        id="firstname"
                        className="form-control"
                        placeholder={t("register.firstname")}
                        value={ data.firstname }
                        onChange={ e => setData({ ...data, firstname: e.target.value }) }
                    />
                </Col>
                <Col>
                    <input
                        required
                        type="text"
                        autoComplete="username lastname"
                        name="lastname"
                        id="lastname"
                        className="form-control"
                        placeholder={t("register.lastname")}
                        value={ data.lastname }
                        onChange={ e => setData({ ...data, lastname: e.target.value }) }
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Col>
                    <input
                        required
                        type="email"
                        autoComplete="username email"
                        name="email"
                        id="email"
                        className="form-control"
                        placeholder={t("register.email")}
                        value={ data.email }
                        onChange={ e => setData({ ...data, email: e.target.value }) }
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Col>
                    <PasswordInput
                        required
                        id="password"
                        name="password"
                        placeholder={t("register.password")}
                        value={ data.password }
                        onChange={ e => setData({ ...data, password: e.target.value }) }
                        userInputs={[data.email, data.firstname, data.lastname]}
                    />
                </Col>
                <Col>
                    <PasswordInput
                        required
                        id="password-confirmation"
                        name="password-confirmation"
                        placeholder={t("register.password-confirmation")}
                        value={ data['password-confirmation'] }
                        onChange={ e => setData({ ...data, 'password-confirmation': e.target.value }) }
                        showStrength={false}
                    />
                </Col>
            </FormGroup>
            {data['password-confirmation'] !== '' && data.password !== data['password-confirmation'] && (
                <div className="text-danger mb-2">{t('password.mismatch')}</div>
            )}

            <Button className="btn btn-lg btn-block btn-dark" disabled={!canSubmit}>
                {isRegistering ?
                    <span>
                        &nbsp;<i className="fa fa-spinner fa-spin"></i>
                    </span>
                    :
                    <span>{t('register.title')}</span>
                }
            </Button>

            {registerError &&
                <div
                    className="alert alert-danger alert-inline mt-3 mb-0"
                    role="alert"
                >
                    <span className="alert-inline-body">
                        {isAccountAlreadyExistsError(registerErrorMessage) ? (
                            <Trans
                                i18nKey="register.account_already_exists"
                                components={{
                                    forgot: <Link to="/login/forgot" />,
                                }}
                            />
                        ) : (
                            registerErrorMessage
                        )}
                    </span>
                </div>
            }
        </Form>
    );
}

export default RegisterForm;
